// extracted by mini-css-extract-plugin
export var content = "_mn-1";
export var divider = "_mn-0";